<template>
  <div class="footer-wrapper">
    <div class="social-wrapper">
      <p class="right-reserved">
        © THEOS.FI. ALL RIGHTS RESERVED | *THIS IS A BETA RELEASE, CODE AUDIT IS
        ON ITS WAY, USAGE ON YOUR OWN RISK
      </p>
      <div class="social-icon-wrapper">
        <a href="https://www.instagram.com/theos.fi/?hl=en">
          <img
            src="@/Common/Icons/footer-instagram.png"
            class="social-icon"
            alt="Instagram"
          />
        </a>
        <a href="https://medium.com/theos-fi">
          <img
            src="@/Common/Icons/footer-medium.png"
            class="social-icon"
            alt="Medium"
          />
        </a>
        <a href="https://twitter.com/theos_fi">
          <img
            src="@/Common/Icons/footer-twitter.png"
            class="social-icon"
            alt="Twitter"
          />
        </a>
        <a href="https://discord.com/invite/RR9UcCvjUH">
          <img
            src="@/Common/Icons/footer-discord.png"
            class="social-icon"
            alt="Discord"
          />
        </a>
        <a href="https://t.me/theos_fi">
          <img
            src="@/Common/Icons/footer-telegram.png"
            class="social-icon"
            alt="Telegram"
          />
        </a>
        <a href="https://www.reddit.com/r/TheosNFT/">
          <img
            src="@/Common/Icons/footer-reddit.png"
            class="social-icon"
            alt="Reddit"
          />
        </a>
        <a href="https://www.linkedin.com/company/theosfi/">
          <img
            src="@/Common/Icons/footer-linkedin.png"
            class="social-icon"
            alt="Linkedin"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" src="@/Common/Styles/AppFooter.scss" scoped></style>
